import React, { useState, useCallback } from "react";
import { Button, Modal, Affix } from "antd";
import styled from "styled-components";
import { FormattedMessage, useIntl } from "react-intl";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import AdminService from "../../services/admin";
import { errorNotification } from "../../lib/utils/notification";

import RegistrationForm from "../RegistrationForm";

const { REACT_APP_RECAPTCHA_V3_PUBLIC_KEY } = process.env;

const CreateAccountModal = () => {
  const { formatMessage } = useIntl();
  const [showModal, setShowModal] = useState(false);

  const handleShowModal = useCallback(() => {
    setShowModal(!showModal);
  }, [showModal]);

  const afterSubmitCallback = useCallback(() => {
    handleShowModal();
    AdminService.getAccountList({ errorNotification: errorNotification(formatMessage) });
  }, [handleShowModal, formatMessage]);

  return (
    <>
      <Affix offsetBottom={15}>
        <StyledButton type="primary" onClick={handleShowModal}>
          <FormattedMessage id="CreateAccountModal.addNewAccount" defaultMessage="Add new account" />
        </StyledButton>
      </Affix>
      <Modal
        title={<FormattedMessage id="CreateAccountModal.title" defaultMessage="Add account form" />}
        visible={showModal}
        footer={null}
        onCancel={handleShowModal}
      >
        <GoogleReCaptchaProvider reCaptchaKey={REACT_APP_RECAPTCHA_V3_PUBLIC_KEY}>
          <RegistrationForm afterSubmitCallback={afterSubmitCallback} adminMode />
        </GoogleReCaptchaProvider>
      </Modal>
    </>
  );
};

const StyledButton = styled(Button)`
  display: block;
  width: 100%;
  justify-content: center;
  margin: ;
`;

export default CreateAccountModal;
